<!-- src/views/pages/finance-accounts/sales/provident-fund.vue -->
<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import { ref, onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import { useProvidentStore } from "@/stores/providentStore";
import ProvidentTable from "./provident-table.vue";
import ProvidentModal from "@/components/modal/provident-modal.vue";
import * as bootstrap from "bootstrap";

const title = "Provident Fund";
const text = "HR";
const text1 = "Provident Fund";

const store = useProvidentStore();
const modalRef = ref(null);
const deleteItemRef = ref(null);
const dateRangeInput = ref(null);

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function openCreate() {
  modalRef.value?.openCreate();
}

function openEdit(row) {
  modalRef.value?.openEdit(row);
}

function openDelete(row) {
  deleteItemRef.value = row;
  const modal = new bootstrap.Modal("#delete_provident_modal");
  modal.show();
}

async function confirmDelete() {
  await store.deleteItem(deleteItemRef.value.id);
  deleteItemRef.value = null;
  bootstrap.Modal.getInstance("#delete_provident_modal")?.hide();
}

function reload() {
  store.fetchAll();
}

onMounted(() => {
  store.fetchAll();

  if (dateRangeInput.value) {
    const start = moment().subtract(6, "days");
    const end = moment();

    new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
      },
      (start, end) => {}
    );
  }
});
</script>

<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <!-- Export -->
          <!-- <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    ><i class="ti ti-file-type-pdf me-1"></i>PDF</a
                  >
                </li>
                <li>
                  <a href="javascript:void(0);" class="dropdown-item rounded-1"
                    ><i class="ti ti-file-type-xls me-1"></i>Excel</a
                  >
                </li>
              </ul>
            </div>
          </div> -->

          <!-- Add -->
          <div class="mb-2">
            <a
              class="btn btn-primary d-flex align-items-center"
              href="javascript:void(0);"
              @click="openCreate"
              v-can="'ProvidentFund.Create'"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Provident Fund
            </a>
          </div>

          <!-- Collapse -->
          <div class="head-icons ms-2">
            <a id="collapse-header" @click="toggleHeader"
              ><i class="ti ti-chevrons-up"></i
            ></a>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="card">
        <div class="card-header d-flex justify-content-between flex-wrap">
          <h5>Provident Fund List</h5>

          <div class="d-flex align-items-center flex-wrap">
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon"
                  ><i class="ti ti-chevron-down"></i
                ></span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <provident-table @edit="openEdit" @delete="openDelete" />
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <ProvidentModal @refresh="reload" ref="modalRef" />

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_provident_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-3 text-center">
        <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
          <i class="ti ti-trash-x fs-36"></i>
        </span>
        <h4 class="mb-1">Confirm Delete</h4>
        <p>
          You want to delete this provident fund record. This cannot be undone.
        </p>

        <div class="d-flex justify-content-center">
          <button class="btn btn-light me-3" data-bs-dismiss="modal">
            Cancel
          </button>
          <button class="btn btn-danger" @click="confirmDelete">
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


